namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.CampaignEligibilityDialog')
    export class CampaignEligibilityDialog extends Serenity.EntityDialog<CampaignEligibilityRow, any> {
        protected getFormKey() { return CampaignEligibilityForm.formKey; }
        protected getIdProperty() { return CampaignEligibilityRow.idProperty; }
        protected getLocalTextPrefix() { return CampaignEligibilityRow.localTextPrefix; }
        protected getNameProperty() { return CampaignEligibilityRow.nameProperty; }
        protected getService() { return CampaignEligibilityService.baseUrl; }
        protected getDeletePermission() { return CampaignEligibilityRow.deletePermission; }
        protected getInsertPermission() { return CampaignEligibilityRow.insertPermission; }
        protected getUpdatePermission() { return CampaignEligibilityRow.updatePermission; }

        protected form = new CampaignEligibilityForm(this.idPrefix);
    }
}